<template>
  <v-card elevation="4">
    <v-card-title>
      <div class="d-sm-flex align-center">
        <div>
          <h3 class="title font-weight-regular">Gráfico de Documentos</h3>
          <h6 class="subtitle-2 font-weight-light">
            Recebidos, Enviados e Lidos
          </h6>
        </div>
        <v-spacer></v-spacer>
      </div>
    </v-card-title>
    <v-card-subtitle>
      <div>
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          :return-value.sync="dates"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              label="Selecione o Período"
              persistent-hint
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
            <v-date-picker
              v-model="dates"
              locale="pt-br"
              no-title
              range
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu1 = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu1.save(dates)"
              >
                OK
              </v-btn>
            </v-date-picker>

        </v-menu>
      </div>
    </v-card-subtitle>
    <v-card-text>
      <v-row align="center" class="mx-0">
        <vue-apex-charts v-if="numberOfReceived"
          type="pie"
          height="300px"
          :options="chartOptions" 
          :series="series"
        >
        </vue-apex-charts>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

import VueApexCharts from "vue-apexcharts";

export default {
  name: "PieChart",
  props: ["numberOfReceived", "numberOfSent", "numberOfRead"],
  components: {
    VueApexCharts,
  },
  data(){
    return {
      menu1: false,
      date: null,
      dates: null,
      dateFormatted: null,
      series: [this.numberOfReceived, this.numberOfSent, this.numberOfRead],
      chartOptions: {
        chart: {
          width: 380,
          type: 'pie',
        },

        labels: ['Recebidos', 'Enviados', 'Lidos'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
    }
  },
  watch: {
    dashboardData(val) {
      console.log()
      if (typeof val.numberOfReceived == 'number') {
        this.numberOfReceived = val.numberOfReceived
        this.numberOfSent = val.numberOfSent
        this.numberOfRead = val.numberOfRead
      }
    },
    numberOfReceived(val) {
      this.series[0] = val
    },
    numberOfSent(val) {
      this.series[1] = val
    },
    numberOfRead(val) {
      this.series[2] = val
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },

  apollo: {
    dashboardData: {
      query: require("@/graphql/queries/Dashboard.gql").getDashboardData,
      variables() {
        return {
          range: this.dates ? this.dates : null
        }
      },
      update: (data) => data.dashBoardQuery,
    },
  },
  computed:{
    dateRangeText () {
      if (!this.dates) {
        return null
      }

      const [year, month, day] = this.dates[0].split('-')
      if (this.dates.length == 1) {
        return `${day}/${month}/${year}`
      }

      const [year2, month2, day2] = this.dates[1].split('-')
      return `${day}/${month}/${year} a ${day2}/${month2}/${year2}`
    },
  },
  mounted() {
    this.$apollo.queries.dashboardData.refetch({
      range:this.dates ? this.dates : null

    })
  }
}
</script>